export default __webpack_public_path__ + "static/media/407_DSC8594.4e20b808.jpg";